import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { LuX, LuSend } from "react-icons/lu";
import { composeEmail } from '../../redux/reducers/communicationSlice';
import { getCustomersByBusiness } from '../../redux/reducers/customerSlice';


const tagsList = ['invoice', 'order', 'support', 'general'];

const ComposeEmailModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { customerList } = useSelector((state) => state.customer);
  const { sendingMessage } = useSelector((state) => state.communication);
  const businessId = useSelector((state) => state.business.selectedBusiness?._id);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (show && businessId) {
      dispatch(getCustomersByBusiness(businessId));
    }
  }, [show, businessId, dispatch]);

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCustomer || !subject || !content) return;

    dispatch(composeEmail({
      businessId,
      customerId: selectedCustomer.value,
      subject,
      content,
      tags: selectedTags
    })).then((res) => {
      if (!res.error) {
        onHide();
        // Reset state
        setSelectedCustomer(null);
        setSubject('');
        setContent('');
        setSelectedTags([]);
      }
    });
  };

  const customerOptions = customerList.map(c => ({
    value: c._id,
    label: `${c.name || 'No Name'} (${c.email})`
  }));

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold" style={{ fontSize: '18px' }}>New Email Conversation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">To (Customer)*</Form.Label>
            <Select
              options={customerOptions}
              value={selectedCustomer}
              onChange={setSelectedCustomer}
              placeholder="Search by name or email..."
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Subject*</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              style={{ borderRadius: '8px' }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold d-block">Tags (optional)</Form.Label>
            <div className="d-flex flex-wrap gap-2">
              {tagsList.map(tag => (
                <span
                  key={tag}
                  className="rounded-pill px-3 py-1 fw-semibold"
                  style={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    background: selectedTags.includes(tag) ? 'rgba(40,176,196,0.15)' : '#f1f5f9',
                    color: selectedTags.includes(tag) ? '#28B0C4' : '#64748b',
                    border: selectedTags.includes(tag) ? '1.5px solid rgba(40,176,196,0.3)' : '1.5px solid #e2e8f0',
                    transition: 'all 0.15s ease'
                  }}
                  onClick={() => toggleTag(tag)}
                >
                  {tag}
                </span>
              ))}
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Message*</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              placeholder="Type your message here..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
              style={{ borderRadius: '8px', minHeight: '140px' }}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" onClick={onHide} className="rounded-3 px-4 fw-semibold">
              Cancel
            </Button>
            <Button 
              type="submit" 
              className="rounded-3 px-4 fw-semibold d-flex align-items-center gap-2"
              style={{ background: '#28B0C4', border: 'none', color: 'white' }}
              disabled={sendingMessage || !selectedCustomer || !subject || !content}
            >
              {sendingMessage ? <Spinner size="sm" /> : <LuSend size={16} />}
              Send Email
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ComposeEmailModal;
